// Hybrid Service Configuration
// This file manages the transition between Supabase and MongoDB
// Now refactored to use Backend API instead of direct MongoDB access (Browser compatible)

import { supabase } from '../supabaseConfig';
// import api from './api'; // Removed as we are using Supabase directly now

class HybridService {
  // Authentication (kept in Supabase)
  async signUp(email, password, userData) {
    try {
      // 1. SignUp in Supabase (Auth)
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: userData
        }
      });

      if (data.user && !error) {
        // 2. Create user profile in Supabase table
        // We use upsert to ensure profile exists
        try {
          const { error: profileError } = await supabase
            .from('users')
            .upsert({
              id: data.user.id,
              email: data.user.email,
              role: userData.role || 'student', // default
              profile_data: userData,
              updated_at: new Date().toISOString()
            });

          if (profileError) console.error("Profile creation error", profileError);

        } catch (apiError) {
          console.error("Failed to sync user to DB:", apiError);
        }
      }

      return { data, error };
    } catch (error) {
      return { data: null, error };
    }
  }

  async signIn(email, password) {
    return await supabase.auth.signInWithPassword({ email, password });
  }

  async signOut() {
    return await supabase.auth.signOut();
  }

  async getCurrentUser() {
    return await supabase.auth.getUser();
  }

  onAuthStateChange(callback) {
    return supabase.auth.onAuthStateChange(callback);
  }

  // User profile operations (Direct Supabase)
  async getUserProfile(userId) {
    try {
      // Fetch from users table first
      const { data, error } = await supabase
        .from('users')
        .select('*')
        .eq('id', userId)
        .single();

      if (error) {
        console.warn("User fetch error", error);
        return { data: null, error };
      }
      return { data, error: null };
    } catch (error) {
      console.error("Error fetching profile:", error);
      return { data: null, error };
    }
  }

  async updateUserProfile(userId, updates) {
    try {
      const { data, error } = await supabase
        .from('users')
        .update(updates)
        .eq('id', userId)
        .select()
        .single();

      return { data, error };
    } catch (error) {
      return { data: null, error };
    }
  }

  // --- ERP / School Data Methods (Stubbed/API-ready) ---
  // These should be implemented as backend routes later.
  // For now, we return empty structure or call future APIs to prevent build errors.

  async getStudents(schoolId, filters = {}) {
    console.warn("getStudents via API not implemented yet");
    return { data: [], error: null };
  }

  // Stubs for other methods to keep interface compatible if used elsewhere
  async getStaff(schoolId) { return { data: [], error: null }; }
  async getClasses(schoolId) { return { data: [], error: null }; }
  async getFees(schoolId) { return { data: [], error: null }; }
  async getExpenses(schoolId) { return { data: [], error: null }; }
  async getAttendance(schoolId) { return { data: [], error: null }; }
  async getActivities(schoolId) { return { data: [], error: null }; }
  async getSchoolStats(schoolId) { return { data: {}, error: null }; }

  // Disconnect no-op
  async disconnect() { }
}

// Create and export singleton instance
const hybridService = new HybridService();
export default hybridService;